import type { PaginationObject } from '#/index'

export const paginationObjetEmpty: () => PaginationObject = () => ({
  rowsNumber: 0,
  descending: false,
  page: 1,
  rowsPerPage: parseInt(import.meta.env.VITE_APP_PAGINATION_LIMIT),
})
